export default __webpack_public_path__ + "static/media/ic_noads.814fc456.svg";